import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { PurchaseResponse, PaginationParams } from './types';

export async function getMemberPurchases(memberId: string, params: PaginationParams = {}) {
  const url = `/web/studio/users/${memberId}/purchases`;

  const queryParams = {
    limit: params.limit ?? 50,
    offset: params.offset ?? 0,
  };

  const response = await api.executeGetRequest<PaginatedListResponse<PurchaseResponse>>(url, queryParams);

  return response.data;
}
